<div class="pwa-install-container">
    <div class="message-title" translate>
        texts.PWA_Install_Title
    </div>
    <div class="message-text" translate>
        texts.PWA_Install_Description
    </div>
    <div class="button-container">
        <button class="install-button" (click)="downloadPwa()" translate>
            texts.PWA_Install_Button
        </button>
        <button class="close-button" (click)="closeDialog()" translate> texts.PWA_Install_Maybe_Later </button>
    </div>
    <div class="blue-corner-element"></div>
</div>